<template>
  <div>
    <worklist
      @select_task="show_task"
      @refresh="refresh_worklist"
      ref="worklist"
      style="margin-left: 15px; margin-right: 15px;"
    />
    <task-viewer
      ref="task_viewer"
      @submitted="submitted"
      style="margin-left: 15px; margin-right: 15px;"
    />
  </div>
</template>

<script>
import Worklist from "./NgineWorkspaceWorklist";
import TaskViewer from "./NgineWorkspaceTaskViewer";

export default {
  name: "NgineWorkspace",
  components: { Worklist, TaskViewer },
  data() {
    return {};
  },
  methods: {
    show_task(task) {
      this.$refs.task_viewer.display(task);
    },
    refresh_worklist() {
      this.$refs.task_viewer.clear();
    },
    submitted(/*resp*/) {
      this.$refs.worklist.refresh_worklist();
    }
  },
  mounted() {},
  watch: {}
};
</script>
